import api from './api';
import { unwrapList, unwrapObject, type ListResult } from './api-envelope';
import type { CategoryListQuery } from './queryKeys';
import type {
  CategoryType,
  CategoryTreeNode,
  CreateCategoryInput,
  UpdateCategoryInput,
} from '@erpgold/shared';

export const categoryService = {
  list: (params: CategoryListQuery): Promise<ListResult<CategoryType>> =>
    api.get('/categories', { params }).then(unwrapList<CategoryType>),

  tree: (): Promise<CategoryTreeNode[]> =>
    api
      .get<{ data: { tree: CategoryTreeNode[] }; success: true }>('/categories/tree')
      .then((r) => r.data.data.tree),

  getById: (id: string): Promise<CategoryType> =>
    api.get(`/categories/${id}`).then(unwrapObject<CategoryType>),

  create: (body: CreateCategoryInput): Promise<CategoryType> =>
    api.post(`/categories`, body).then(unwrapObject<CategoryType>),

  update: (id: string, body: UpdateCategoryInput): Promise<CategoryType> =>
    api.put(`/categories/${id}`, body).then(unwrapObject<CategoryType>),

  remove: (id: string): Promise<void> =>
    api.delete(`/categories/${id}`).then(() => undefined),

  reorder: (orders: { id: string; ordering: number }[]): Promise<void> =>
    api.patch(`/categories/ordering`, { orders }).then(() => undefined),
};
